import CancelIcon from '@mui/icons-material/Cancel';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import photo from '../../../../../../assets/images/homeImage.png';
import Player from '../../../../../Player/Player';
import styles from './contentDesktop.module.scss';
import { useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import colors from '../../../../../../utils/colors';
import CircularProgressWithLabel from '../../../../../CreateVideo/CircularProgressWithLabel';

const mapStateToProps = (state) => {
    return {
        upload: state.common.upload
    };
};

const ContentMobile = (props) => {
    const { t } = useTranslation();
    const uniqueHash = useMemo(() => uuidv4(), []);
    const trailerInputRef = useRef(null);
    const upload = props.upload.find((x) => x.jobId === props.jobId);
    const [isPortrait, setIsPortrait] = useState(false);
    const fileInputRef = useRef(null);

    return (
        <Box className={styles.thumbnailAndTrailer}>
            <Box className={styles.flexGap}>
                {props.showLoader ? (
                    <Box
                        sx={{
                            marginBottom: '1rem',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            minheight: '300px'
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}>
                            <CircularProgress sx={{ color: colors.primary }} />
                            <Typography>The new trailer is converting</Typography>
                        </Box>
                    </Box>
                ) : (
                    <>
                        {props.event.trailerUrl && !props.trailerFile ? (
                            <Box className={styles.box}>
                                <Player
                                    style={{ borderRadius: '12px' }}
                                    uniqueHash={props.uniqueHash}
                                    streamSource={props.event.trailerUrl}
                                    muted={false}
                                    sound={true}
                                    autoplay={false}
                                    event={props.event}
                                    setIsPortrait={setIsPortrait}
                                />
                            </Box>
                        ) : (
                            <Box className={styles.box}>
                                <Box
                                    style={{
                                        position: 'relative',
                                        width: '100%',
                                        border: props.fileUploadError
                                            ? '1px solid red'
                                            : '1px solid white',
                                        borderRadius: '9px',
                                        height: '100%'
                                    }}>
                                    {props.trailerFile ? (
                                        <>
                                            <img
                                                style={{
                                                    borderRadius: '14px',
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    aspectRatio: 16 / 9
                                                }}
                                                src={photo}
                                                alt="photo"
                                            />
                                            {upload?.trailer_show && (
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        borderRadius: '14px',
                                                        width: '100%',
                                                        height: '100%',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        zIndex: 999
                                                    }}>
                                                    <CircularProgressWithLabel
                                                        size={40}
                                                        color={colors.primary}
                                                        showValue={false}
                                                        value={upload.trailer_progress}
                                                    />
                                                </Box>
                                            )}
                                            <IconButton
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    props.deleteTrailer();
                                                }}
                                                sx={{
                                                    background: 'white',
                                                    padding: '0px',
                                                    width: '20px',
                                                    height: '20px',
                                                    position: 'absolute',
                                                    top: '5px',
                                                    right: '5px',
                                                    '&:active, &:focus, &:hover': {
                                                        background: 'white'
                                                    }
                                                }}>
                                                <CancelIcon
                                                    sx={{ width: '20px', height: '20px' }}
                                                    color={colors.primaryDarkGray}
                                                />
                                            </IconButton>
                                        </>
                                    ) : (
                                        <Box
                                            onClick={() =>
                                                trailerInputRef.current &&
                                                trailerInputRef.current.click()
                                            }
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                cursor: 'pointer'
                                            }}>
                                            <VideoCallIcon />
                                            <Typography fontSize={'10px'}>
                                                {t('AddTrailer')}
                                            </Typography>
                                        </Box>
                                    )}
                                    {!upload?.trailer_show && (
                                        <Box>
                                            <input
                                                type="file"
                                                id="uploadTrailer"
                                                accept="video/*"
                                                onChange={(e) =>
                                                    props.handleVideoUpload(e, 'trailer')
                                                }
                                                style={{ display: 'none' }}
                                                ref={trailerInputRef}
                                            />
                                        </Box>
                                    )}
                                </Box>
                                {props.fileUploadError && (
                                    <Typography sx={{ marginTop: '1rem', color: 'red' }}>
                                        {props.fileUploadError}
                                    </Typography>
                                )}
                            </Box>
                        )}
                    </>
                )}
                {props.thumbnail && (
                    <Box className={styles.box}>
                        <Player
                            key={props.imagePreview ?? props.thumbnail}
                            style={{ borderRadius: '12px' }}
                            uniqueHash={uniqueHash}
                            streamSource={props.event.live_stream_url}
                            muted={false}
                            sound={true}
                            autoplay={false}
                            event={props.event}
                            setIsPortrait={setIsPortrait}
                            thumbnail={props.imagePreview ?? props.thumbnail}
                        />
                    </Box>
                )}
            </Box>
            <Box className={styles.flexBetweenGap} sx={{ flexDirection: 'row-reverse' }}>
                <Box className={styles.boxText}>
                    <Typography fontSize={'14px'}>{t('Thumbnail')}</Typography>
                    <Box
                        className={styles.boxTextBox}
                        onClick={() => {
                            if (fileInputRef.current) {
                                fileInputRef.current.click();
                            }
                        }}>
                        {t('UploadNew')}
                        <input
                            type="file"
                            id="thumbnailUpload"
                            key={props.imagePreview || 'default'}
                            style={{ display: 'none' }}
                            ref={fileInputRef}
                            onChange={props.handleImageChange}
                            accept="image/*"
                        />
                    </Box>
                </Box>
                <Box className={styles.boxText}>
                    {props?.event?.trailerUrl && (
                        <>
                            <Typography fontSize={'14px'}>{t('Trailer')}</Typography>

                            <Box
                                className={styles.boxTextBox}
                                onClick={() =>
                                    trailerInputRef.current && trailerInputRef.current.click()
                                }>
                                {t('UploadNew')}
                                <input
                                    type="file"
                                    id="uploadTrailer"
                                    accept="video/*"
                                    onChange={(e) => props.handleVideoUpload(e, 'trailer')}
                                    style={{ display: 'none' }}
                                    ref={trailerInputRef}
                                />
                            </Box>
                        </>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default connect(mapStateToProps, null)(ContentMobile);
